(function () {
  function togglePageSections(hideOthers) {
    var allSections = document.querySelectorAll('.main-content .shopify-section');
    for (var i = 1; i < allSections.length; i += 1) {
      allSections[i].style.display = hideOthers ? 'none' : 'block';
    }
  }

  function activateTestingTab(root, index) {
    var tabs = root.querySelectorAll('[data-testing-pr-tab]');
    var panels = root.querySelectorAll('[data-testing-pr-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-testing-pr-tab') === String(index);
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-testing-pr-panel') === String(index);
      panel.hidden = !isActive;
    });

    var activeTab = root.querySelector('[data-testing-pr-tab="' + index + '"]');
    var shouldHideSections =
      activeTab &&
      activeTab.textContent.trim() !== 'Description' &&
      window.location.href.indexOf('agh550-air-purifier') === -1;

    togglePageSections(shouldHideSections);
  }

  function initTestingPrSection(root) {
    if (!root || root.dataset.testingPrInit === '1') return;
    root.dataset.testingPrInit = '1';

    root.querySelectorAll('[data-testing-pr-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTestingTab(root, tab.getAttribute('data-testing-pr-tab'));
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var tabs = Array.from(root.querySelectorAll('[data-testing-pr-tab]'));
        var currentIndex = tabs.indexOf(tab);
        if (currentIndex < 0) return;
        var nextIndex =
          event.key === 'ArrowRight'
            ? (currentIndex + 1) % tabs.length
            : (currentIndex - 1 + tabs.length) % tabs.length;
        tabs[nextIndex].click();
        tabs[nextIndex].focus();
      });
    });

    activateTestingTab(root, '1');
  }

  function initAll() {
    document.querySelectorAll('[data-testing-pr-section]').forEach(initTestingPrSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-testing-pr-section]').forEach(initTestingPrSection);
  });
})();
